import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HomeTxtsKey } from 'src/app/components/pages/home/h-interfaces/txt-h-keys/home-txt-key.interface';
import { homeImgsKeys } from '../../pages/home/h-interfaces/img-h-keys/home-img-key.interface';

@Component({
    selector: 'app-homeone-banner',
    templateUrl: './homeone-banner.component.html',
    styleUrls: ['./homeone-banner.component.scss']
})
export class HomeoneBannerComponent {
	@Input() imgHeader?: string;
	@Input() imgBanner?: homeImgsKeys;
	@Input() texts?: HomeTxtsKey;

	@Output() scrollToChat = new EventEmitter<void>();

	get bannerSrc(): string | undefined {
		return this.imgHeader || this.imgBanner?.banner;
	}

	onScrollToChat() {
		this.scrollToChat.emit();
	}
}
